import styled from 'styled-components';

// ----------------------------------------------------------------------

export const Header = styled.header`
  width: 100%;
  height: 70px;
  padding: 0 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #FFFFFF;

  > div {
    display: flex;
    align-items: center;
  }
    
  ${({theme}) => theme.media.xxl`
    padding: 0 20px;
  `};
    
  ${({theme}) => theme.media.md`
    padding: 0 10px;
  `};
`;

export const Logo = styled.div`
  width: 180px;
  height: 32px;
  background-image: url(/assets/logo/logo.svg);
  background-size: 100% auto;
  background-position: center center;
  background-repeat: no-repeat;
`;

export const Main = styled.main`
  width: 100%;
  padding-top: 70px;
`;

export const Footer = styled.footer`
  width: 100%;
  height: 230px;
  padding: 30px 100px 0;
  color: ${({theme}) => theme.colors.grayscale[500]};
  line-height: 20px;
  background-color: #FFFFFF;

  > div {
    display: flex;

    > p {
      width: 100px;
      color: ${({theme}) => theme.colors.grayscale[800]};
    }
  }

  > div:first-child {
    margin-bottom: 20px;

    > div {
      display: flex;

      > p {
        margin-right: 25px;
        &:last-child {
          margin-top: 20px;
        }
      }
    }
  }

  > div:nth-child(2) {

    > p:nth-child(3) {
      width: 140px;
      margin-left: 63px;
    }

    > div > div {
      display: flex;
      align-items: center;
      margin-top: 3px;

      > p {
        color: ${({theme}) => theme.colors.grayscale[600]};
      }
      
      > div {
        display: flex;
        align-items: center;
      }

      > div > div {
        width: 16px;
        height: 16px;
        background-size: 100% auto;
        background-position: center center;
        background-repeat: no-repeat;
        margin-right: 3px;
      }
      
      > i {
        display: block;
        width: 1px;
        height: 10px;
        background-color: ${({theme}) => theme.colors.grayscale[300]};
        margin: 0 12px;
      }
    }
    
    > div:nth-child(2) > div > div:first-child > div,
    > div:last-child > div > div:last-child > div {
      background-image: url(/assets/main/phone.svg);
    }

    > div:nth-child(2) > div > div:last-child > div {
      background-image: url(/assets/main/email.svg);
    }

    > div:last-child > div > div:first-child > div {
      background-image: url(/assets/main/user.svg);
    }
  }
  
  > p {
    width: 100%;
    text-align: center;
    color: ${({theme}) => theme.colors.grayscale[200]};
    padding-top: 25px;
    margin-top: 25px;
    border-top: 1px solid ${({theme}) => theme.colors.grayscale[200]};
  }
    
  ${({theme}) => theme.media.xxl`
    height: auto;
    padding: 20px;

    > p {
      padding: 25px 0;
    }
  `};
    
  ${({theme}) => theme.media.xl`
    > div {
      display: block;

      &:nth-child(2) > p:nth-child(3) {
        width: auto;
        margin-left: 0;
        margin-top: 10px;
      }
    }
  `};
    
  ${({theme}) => theme.media.slg`
    > div:first-child > div {
      display: block;
      
      > p:last-child {
        margin-top: 0;
      }
    }
  `};
    
  ${({theme}) => theme.media.md`
    padding: 10px;

    > p {
      padding: 15px 0 10px;
    }
  `};
    
  ${({theme}) => theme.media.sm`
    > div:nth-child(2) > div > div {
      display: block;

      i {
        display: none;
      }
    }
  `};
`;